import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';  // Import the auth hook

const PrivateRoute = ({ element }) => {
  const auth = useAuth();

  // If not authenticated, redirect to login page
  if (!auth.isAuthenticated) {
    return <Navigate to="/" />;
  }

  // If authenticated, render the element (e.g., Dashboard)
  return element;
};

export default PrivateRoute;
